import axiosBaseApi from '../common/lib/axiosBaseApi';
import { Friend, FriendRequest } from './friendsServicesTypes';

export const getFriends = () => {
  return axiosBaseApi.get<Friend[]>(`/v1/friends`);
};

export const getFriendsRequest = () => {
  return axiosBaseApi.get<{ sent: FriendRequest[]; received: FriendRequest[] }>(`/v1/friends/requests`);
};

export const postFriendRequest = (userId: string) => {
  return axiosBaseApi.post(`/v1/friends/requests`, { userId });
};

export const patchFriendRequest = (userId: string, accept: boolean) => {
  return axiosBaseApi.patch(`/v1/friends/requests/${userId}`, { accept });
};

export const deleteFriend = (id: string) => {
  return axiosBaseApi.delete(`/v1/friends/${id}`);
};
